"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TourPulse = void 0;
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var react_1 = __importDefault(require("react"));
var c = (0, BemBuilder_1.default)("tour-pulse");
var TourPulse = function () {
    return (react_1.default.createElement("div", { className: c() }, [160, 140, 120, 100].map(function (itemSize, itemIndex) { return (react_1.default.createElement("div", { key: itemSize, className: c("item"), style: {
            "--size": "".concat(itemSize, "%"),
            "--delay": "".concat(0.1 * itemIndex, "s"),
        } })); })));
};
exports.TourPulse = TourPulse;
